import React, { useContext } from 'react';
import { getAnonCategories } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';

export interface FooterLink {
  title?: string;
  url?: string;
  anchorAttributes?: {
    rel: string;
  };
  isTitle?: boolean;
  lastItem?: boolean;
}

const AnonFooterLinks = () => {
  const { domain, lang, country, variant, onetrustBannerEnabled } = useContext(
    SMFooterContext
  );

  const categories = getAnonCategories(domain, lang, country, variant);
  const margin = variant === 'slim';
  return (
    <>
      {categories.map((category, i) => (
        <InlineList key={category[0].title} noMargin={margin}>
          {category.map((item: FooterLink) => (
            <InlineListItem
              href={item.url}
              anchorAttributes={item.anchorAttributes}
              key={item.title}
              isTitle={item.isTitle}
              lastItem={item.lastItem}
            >
              {item.title}
            </InlineListItem>
          ))}
          <If condition={i === 2 && !!onetrustBannerEnabled}>
            {/* Onetrust pipes in the text content here */}
            <InlineListItem
              href="#cookiePreferences"
              className="ot-sdk-show-settings"
              data-testid="AnonFooterLinks__cookiePreferences"
              lastItem
            />
          </If>
        </InlineList>
      ))}
    </>
  );
};

export default AnonFooterLinks;
